import(/* webpackMode: "eager", webpackExports: ["MarketingPageShell","AboutPageContent"] */ "/opt/render/project/src/src/modules/landing/pages/LandingPage.tsx");
